import { SubflowMessengerAction } from 'lib-shared-types-api';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { FlowT } from 'hocs/flows/api/types';

import { FlowMessengerAction } from './flow.types';

export function formatFlowForBackend(
  flow: FlowT<FlowMessengerAction, SubflowMessengerAction>,
): FlowT<FlowMessengerAction, SubflowMessengerAction> {
  return {
    ...flow,
    subflows: flow.subflows?.map((subflow) => ({
      ...subflow,
      actions: subflow.actions.map((action) => ({
        ...action,
        overlay: [],
        pageX: Math.round(action.pageX),
        pageY: Math.round(action.pageY),
        nodeType:
          // Replace the init node with subflow init node (expected by the backend)
          action.nodeType === FlowNodeTypes.INIT
            ? FlowNodeTypes.SUBFLOW_INIT
            : action.nodeType,
      })),
    })),
  } as FlowT<FlowMessengerAction, SubflowMessengerAction>;
}
